import type { CityConfig } from "@/pages/city-template/types";

export const olatheConfig: CityConfig = {
  city: "Olathe",
  state: "Kansas",
  stateAbbr: "KS",
  slug: "olathe",
  route: "/cities/olathe",
  title: "Emergency Passport Olathe, KS — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Olathe, KS — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Olathe and Johnson County travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Olathe, Kansas",
  heroSubtitle: "Passport expired before your family vacation to Mexico? Flying out of MCI in days? Fast Passport Center helps Olathe travelers get their passports fast — as fast as 24 hours. A+ BBB rated. No office visit required for most services.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Olathe%20Kansas%20suburban%20downtown%20with%20historic%20courthouse%20square%20and%20modern%20commercial%20development%2C%20Johnson%20County%20seat%2C%20tree-lined%20streets%20with%20autumn%20amber%20foliage%2C%20Midwestern%20small%20city%20charm%20blended%20with%20contemporary%20growth%2C%20warm%20golden%20hour%20sun%20highlighting%20red%20brick%20architecture%2C%20clean%20sidewalks%20and%20community%20feel&width=1800&height=700&seq=olathe-hero-01&orientation=landscape",
  heroImageAlt: "Olathe Kansas suburban downtown with historic courthouse and modern development",
  geoPosition: "38.8814;-94.8190",
  geoPlacename: "Olathe, Kansas",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 510 miles northeast — nearest regional passport agency for Kansas City metro travelers",
  },
  nearbyCitiesZips: [
    { name: "Olathe", zips: "66051–66063" },
    { name: "Overland Park", zips: "66204–66225" },
    { name: "Lenexa", zips: "66214–66227" },
    { name: "Gardner", zips: "66030–66031" },
    { name: "Spring Hill", zips: "66083" },
    { name: "De Soto", zips: "66018–66019" },
    { name: "Lawrence", zips: "66044–66049" },
    { name: "Shawnee", zips: "66203–66226" },
    { name: "Kansas City", zips: "66101–66160" },
    { name: "Baldwin City", zips: "66006" },
    { name: "Eudora", zips: "66025" },
  ],
  benefits: [
    { icon: "ri-computer-line", title: "Start 100% Online", desc: "No office visit required to begin. Complete your order from home or work in Olathe in minutes." },
    { icon: "ri-truck-line", title: "Ship Overnight from Johnson County", desc: "FedEx and UPS locations throughout Olathe and the KC metro offer overnight shipping to our processing center." },
    { icon: "ri-shield-check-line", title: "Expert Document Review", desc: "Every application is reviewed by our team before submission to reduce errors and delays — especially important for last-minute passport needs." },
    { icon: "ri-calendar-check-line", title: "Reserved Agency Access", desc: "We hold reserved submission slots at the nearest regional passport center — no public appointment hunting needed." },
  ],
  testimonials: [
    {
      name: "Rebecca W.",
      location: "Olathe, KS",
      rating: 5,
      text: "Our family cruise to the Caribbean was just 3 weeks away when we realized two passports had expired. Fast Passport Center handled both renewals from our home in Olathe. Both passports were back in 8 days. Such a relief.",
      service: "Passport Renewal",
    },
    {
      name: "Mark T.",
      location: "Olathe, KS",
      rating: 5,
      text: "I got called for a last-minute business trip to Japan and my passport had expired. Fast Passport Center got it renewed in 5 days. Shipped from the FedEx on Santa Fe and had it back before my flight from MCI. Incredible.",
      service: "Emergency Passport",
    },
    {
      name: "Jennifer P.",
      location: "Gardner, KS",
      rating: 5,
      text: "Needed a new passport for our teenager heading to Europe with a school group. Fast Passport Center made the whole process stress-free. The checklist they provided was perfect — we had everything right the first time.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "olathe-east-post",
      name: "Olathe East Post Office",
      type: "USPS Passport Acceptance",
      address: "15050 W 138th St",
      city: "Olathe",
      state: "KS",
      zip: "66062",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4:30pm",
      distance: "East Olathe",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Primary passport acceptance location in Olathe. Appointment required — book online well in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "johnson-county-clerk",
      name: "Johnson County Clerk's Office",
      type: "County Passport Acceptance",
      address: "111 S Cherry St, Suite 1500",
      city: "Olathe",
      state: "KS",
      zip: "66061",
      phone: "913-715-3300",
      hours: "Mon–Fri 8am–4:30pm (by appointment)",
      distance: "Downtown Olathe — Johnson County Courthouse",
      website: "https://www.jocogov.org/",
      websiteLabel: "Johnson County Government",
      notes: "County clerk passport acceptance in downtown Olathe. Appointment recommended. Often faster scheduling than USPS locations.",
      icon: "ri-government-line",
    },
    {
      id: "olathe-main-post",
      name: "Olathe Main Post Office",
      type: "USPS Passport Acceptance",
      address: "300 E Loula St",
      city: "Olathe",
      state: "KS",
      zip: "66061",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4pm",
      distance: "Downtown Olathe",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Downtown Olathe location for central and western residents.",
      icon: "ri-mail-line",
    },
    {
      id: "gardner-post",
      name: "Gardner Post Office",
      type: "USPS Passport Acceptance",
      address: "100 S Elm St",
      city: "Gardner",
      state: "KS",
      zip: "66030",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4pm",
      distance: "Gardner — about 10 miles southwest",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Convenient for southern Olathe and Gardner area residents.",
      icon: "ri-mail-line",
    },
  ],
  faqs: [
    {
      q: "Can I get an emergency passport in Olathe before international travel?",
      a: "Yes. Through Fast Passport Center, Olathe travelers can get an expedited passport in as little as 2–9 business days, and emergency processing is available in as fast as 24 hours depending on your eligibility and travel documentation.",
    },
    {
      q: "How fast can I renew my passport in Olathe?",
      a: "Fast passport renewal in Olathe is available through Fast Passport Center in as little as 3 business days. Renewal applications are eligible if your current passport was issued at age 16 or older and within the last 15 years. No office visit required for most renewals.",
    },
    {
      q: "Does Olathe have a passport agency?",
      a: "Olathe, Kansas does not have a regional passport agency. The closest regional passport center is the Chicago Passport Agency in Hot Springs, Arkansas. Fast Passport Center is the faster and more convenient solution for most Olathe residents.",
    },
    {
      q: "Can I expedite a child passport in Olathe?",
      a: "Yes. Child passport expediting in Olathe is possible through Fast Passport Center. Child passports for minors 15 and under require an in-person acceptance step with parental consent. We provide a clear checklist and instructions.",
    },
    {
      q: "How long does a standard passport take in Olathe?",
      a: "If you apply through a standard post office acceptance facility in Olathe, processing times run 6–13 weeks. If your travel is sooner than that, you need expedited processing. Fast Passport Center offers Olathe travelers processing as fast as 24 hours.",
    },
    {
      q: "What airports do Olathe passport holders typically fly from?",
      a: "Kansas City International Airport (MCI) is the primary airport for Olathe travelers, about 40 miles north. Direct international flights available. Fast Passport Center can help you meet your deadline.",
    },
    {
      q: "Can I get a passport renewal near me in Olathe without visiting an office?",
      a: "Yes. Most Olathe adults who are renewing a passport can do so entirely by mail — no in-person visit required. Start your order online with Fast Passport Center and ship from any FedEx or UPS in Olathe.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Olathe", address: "15100 W 119th St, Olathe, KS 66062", hours: "Daily 8 AM – 10 PM" },
    { name: "CVS — Olathe", address: "13505 S Mur-Len Rd, Olathe, KS 66062", hours: "Daily 7 AM – 10 PM" },
    { name: "FedEx Office — Olathe", address: "15225 W 135th St, Olathe, KS 66062", hours: "Mon–Fri 7 AM – 10 PM" },
    { name: "Walgreens — Gardner", address: "745 E Main St, Gardner, KS 66030", hours: "Daily 8 AM – 10 PM" },
    { name: "CVS — Overland Park", address: "11900 College Blvd, Overland Park, KS 66210", hours: "Daily 7 AM – 10 PM" },
  ],
  dmvLocations: [
    {
      name: "Olathe Driver License Office",
      address: "13500 S Mur-Len Rd, Suite B, Olathe, KS 66062",
      hours: "Mon–Fri 7 AM – 5:45 PM",
      note: "Main Johnson County DMV in Olathe. Driver licenses, REAL ID, ID cards.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "MCI",
      name: "Kansas City International Airport",
      distance: "Primary international airport — 40 miles north",
      address: "1 International Sq, Kansas City, MO 64153",
      note: "MCI is the closest major airport for Olathe travelers with direct international flights.",
      flightUrl: "https://www.flykci.com/",
      flightLabel: "MCI Airport Website",
      featured: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line", title: "Emergency Passport",
      description: "Flying from MCI in 24–72 hours? Our emergency courier service is designed for urgent, last-minute travel from Olathe and the KC metro.",
      bullets: ["As fast as 24 hours", "Reserved agency submission slots", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line", title: "Passport Renewal",
      description: "Already have a U.S. passport? We help Olathe and Johnson County travelers renew fast.",
      bullets: ["Eligible for expedited processing", "Ship from any FedEx or UPS in Olathe", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-search-eye-line", title: "Lost Passport Replacement",
      description: "Lost your passport before a trip? We guide Olathe travelers through Form DS-64 and the replacement process.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line", title: "Child Passport",
      description: "Child passport expedited service for Olathe families — we provide clear instructions and checklists.",
      bullets: ["Both parents must typically consent", "Clear checklist provided", "Expedited options after acceptance step"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-add-line", title: "New Passport",
      description: "First-time passport application assistance for Olathe residents.",
      bullets: ["Step-by-step checklist", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-truck-line", title: "Passport Courier Service",
      description: "Registered U.S. Department of State courier — we submit through reserved agency channels.",
      bullets: ["State Dept. registered courier", "Reserved daily submission slots", "Not affected by government shutdowns"],
      badge: "Registered Courier",
      link: "https://fastpassportcenter.com/checkout/",
    },
    {
      icon: "ri-edit-line", title: "Name Change & Other Services",
      description: "Passport name changes after marriage or divorce, damaged passport replacement, second passports.",
      bullets: ["Name change after marriage/divorce", "Damaged passport replacement", "Second passport for frequent travel"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Olathe, Kansas travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for Olathe, KS residents with a passport issued within the last 15 years at age 16 or older." },
    { name: "Child Passport", description: "Expedited child passport services for Olathe families with minors under 16." },
  ],
  mistakes: [
    { icon: "ri-time-line", title: "Waiting Too Long to Apply", description: "Olathe travelers often assume 6–8 weeks is safe — it's not. Government processing has stretched to 10–14+ weeks during peak travel season." },
    { icon: "ri-camera-off-line", title: "Wrong Passport Photo", description: "Photos from drugstores and photo booths often get rejected. We provide exact specs and can catch these issues before documents are submitted." },
    { icon: "ri-file-damage-line", title: "Incomplete or Incorrect Forms", description: "One wrong date, one missing signature — your application gets sent back and you lose weeks." },
    { icon: "ri-calendar-close-line", title: "Assuming the Post Office is Fast Enough", description: "Standard USPS passport processing out of Olathe runs 6–13 weeks. If your trip is in under 10 weeks, use our courier service." },
    { icon: "ri-map-pin-time-line", title: "Name Mismatch Across Documents", description: "Your passport name must match your airline ticket exactly. Middle names and hyphens cause more rejections than you'd expect." },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose your processing speed based on your Olathe travel date." },
    { number: "02", icon: "ri-file-list-3-line", title: "Receive Your Personalized Checklist", description: "We send you exactly what you need — nothing more." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Documents Overnight from Olathe", description: "Drop off at any FedEx or UPS in Olathe or the KC metro." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit your application through reserved passport agency slots." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport is Completed", description: "Your passport is completed and shipped back to you." },
  ],
  processingOptions: [
    {
      speed: "2–9", unit: "Business Days", label: "Fast Passport Center",
      tag: "Most Popular", tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Document review included", "Dedicated agent assigned", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5", unit: "Weeks", label: "Fast Passport Center",
      tag: "Standard Expedited", tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Document review included"],
      highlight: false, smartSaver: true,
    },
    {
      speed: "1–2", unit: "Months", label: "Self-Service (Post Office)",
      tag: "Slowest", tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access", "In-person clerk appointment required", "No document review", "Not suitable if travel is within 10 weeks"],
      highlight: false, muted: true,
    },
    {
      speed: "24", unit: "Hours*", label: "Regional Agency Processing",
      tag: "Emergency Only", tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required", "Life-or-death emergencies only"],
      highlight: false, emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — limited slots at Chicago Passport Agency", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Must drive to Hot Springs, AR (5.5 hours)", fpc: "Ship documents overnight from Olathe" },
    { feature: "Processing Speed", agency: "Urgent travel only", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection", fpc: "Professional review included" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission slots" },
    { feature: "Government Shutdowns", agency: "Operations may be impacted", fpc: "Not affected by government shutdowns" },
    { feature: "Turnaround Predictability", agency: "Depends on appointment availability — no guarantee", fpc: "Guaranteed processing within selected timeframe" },
    { feature: "Customer Support", agency: "Government clerk — limited availability", fpc: "Dedicated agent assigned to your case with daily updates" },
    { feature: "Travel Required", agency: "Yes — must travel to Chicago in person", fpc: "No — ship documents from home or office in Olathe" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Acceptance Locations", href: "#acceptance-facilities" },
    { label: "vs. Regional Agency", href: "#comparison" },
    { label: "FAQ", href: "#faq" },
    { label: "Local Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Overland Park", route: "/cities/overland-park" },
    { name: "Fast passport renewal in Lenexa", route: "/cities/lenexa" },
    { name: "Emergency passport help near Lawrence", route: "/cities/lawrence" },
    { name: "Fast passport renewal for Johnson County", route: "/states/kansas" },
  ],
  fpcOfficeNote: "After signing up online, we send your personalized checklist and shipping instructions. Ship your documents overnight from any FedEx or UPS location in Olathe or the Kansas City metro area.",
  fpcOfficeDistance: "Serving Olathe and all of Johnson County remotely",
  serviceAreaIntro: "Whether you are in Olathe, Gardner, Spring Hill, De Soto, or anywhere in southern Johnson County, Fast Passport Center makes expedited passport processing simple.",
  nearbyCitiesIntro: "We serve all Olathe and southern Johnson County zip codes. Ship overnight and your documents are at our processing center the next morning.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Olathe as simple as possible.",
  mistakesIntro: "These mistakes cause the most delays and rejections for Olathe travelers. We review your documents before submission.",
  testimonialsIntro: "Real reviews from Olathe and Johnson County travelers who needed their passports fast.",
  faqIntro: "The most common questions Olathe and Johnson County travelers ask about emergency and expedited passport services.",
  statePageRoute: "/states/kansas",
  statePageName: "Kansas",
};